<template>
  <v-container
    fluid
    class="pa-0"
    fill-height
  >
    <template>
      <v-layout align-space-around justify-space-between column fill-height>
        <v-toolbar>
          <v-btn icon @click="$emit('fechar')">
            <v-icon color="grey">arrow_back</v-icon>
          </v-btn>
          <v-toolbar-title>Conferir o dia {{ consolidacao.competencia }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <span v-if="fechado">APENAS VISUALIZAÇÃO</span>
          <v-btn v-else-if="status.pendentes > 0" round color="info" @click="$root.$emit('saveDataConsolidacaoAbastecimento')"><v-icon left dark>save</v-icon>SALVAR</v-btn>
          <v-btn v-else-if="(timeline && status.concluidos === timeline.length) || !timeline" @click="$emit('fecharConsolidacao')" round color="success"><v-icon left dark>check</v-icon>CONCLUIR</v-btn>
          <span v-else>NENHUMA ALTERAÇÃO</span>
        </v-toolbar>
        <v-flex grow>
          <v-card style="height: 100%">
              <v-card-title>
                <v-spacer></v-spacer>
                <v-card class="text-xs-center pa-3 elevation-3" style="border-radius: 1em;">
                  <h4>No sistema</h4>
                  <h3>{{ timeline ? timeline.length : 0 }}</h3>
                </v-card>
                <v-spacer></v-spacer>
                <v-card class="text-xs-center pa-3 elevation-3" style="border-radius: 1em;">
                  <h4>Em planilha</h4>
                  <h3>{{files[0] ? files[0].length : 0}}</h3>
                </v-card>
                <v-spacer></v-spacer>
              </v-card-title>
              <v-divider></v-divider>
              <v-layout row>
                <v-flex  v-if="!fechado" v-show="!$vuetify.breakpoint.xs" xs3>
                  <v-layout column align-center fill-height>
                    <v-flex shrink>
                      <v-layout pl-3 pt-5 column align-center fill-height>
                        <div center>
                          <h1 style="text-align: center">Progresso de consolidação</h1>
                        </div>
                      </v-layout>
                    </v-flex>
                    <v-flex grow pl-3>
                      <div class="excel-consolidar" style="height: 50px">
                        <vue-dropzone ref="myVueDropzone" :useCustomSlot="true"
                        @vdropzone-file-added="fileadded"
                        @vdropzone-file-added-manually="fileadded" id="drop" :options="dropzoneOptions" @vdropzone-success="handleDrop" @vdropzone-drag-over="handleDragover" @vdropzone-drag-enter="handleDragover">
                          <div class="dropzone-custom-content">
                            <h3 class="dropzone-custom-title">Arraste seus arquivos de consolidação para cá</h3>
                            <div class="subtitle">...ou clique para selecionar um arquivo do computador</div>
                          </div>
                        </vue-dropzone>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex :xs9="!$vuetify.breakpoint.xs && !fechado">
                  <v-container fluid v-if="timeline" class="scroll-y" grid-list-lg :style="{'height': 'calc(100vh - 70px)', 'max-height': 'calc(100vh - 70px)'}">
                    <v-data-table
                      :headers="headers"
                      :items="timeline"
                      item-key="tid"
                      hide-actions
                      class="no-overflow"
                    >
                      <template v-slot:items="props">
                        <tr :props="props" @setItem="updateElement" is="consolida-timeline">
                        </tr>
                      </template>
                    </v-data-table>

                    <!-- <v-timeline align-top dense>
                      <template v-for="(value, key) in timeline">
                        <v-timeline-item
                          class="mb-0 pa-0"
                          hide-dot
                          small
                          :key="`time-${key}`"
                        >
                          <span>{{key}}</span>
                        </v-timeline-item>

                        <template v-for="(compensacao) in value">
                          <consolida-timeline
                            :value="compensacao" :key="compensacao.tid">
                          </consolida-timeline>
                        </template>
                      </template>
                    </v-timeline> -->
                  </v-container>
                </v-flex>
              </v-layout>
            <v-divider></v-divider>
          </v-card>
        </v-flex>
      </v-layout>
    </template>
  </v-container>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import ConsolidaTimeline from '@/components/dialogs/ConsolidaVoucherTimeline'
const ExcelJS = require('exceljs')

// eslint-disable-next-line no-unused-vars
function workbookToJson (workbook) {
  var result = {}
  workbook.SheetNames.forEach(function (sheetName) {
    // var roa = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName])
    // if (roa.length > 0) {
    //  result[sheetName] = roa
    // }
  })
  return result
}

export default {
  components: { vueDropzone: vue2Dropzone, consolidaTimeline: ConsolidaTimeline },
  props: ['consolidacao', 'fechado'],
  data () {
    return {
      report: null,
      files: [],
      events: [],
      input: null,
      nonce: 0,
      headers: [
        { text: '', sortable: false, value: 'STATUS', align: 'left', width: '0px', class: 'pl2 pr-2' },
        {
          text: 'Código',
          align: 'left',
          sortable: false,
          value: 'CODIGO',
          class: 'pa-0'
        },
        { text: 'Cliente/CPF', sortable: false, align: 'left', value: 'CLIENTE', class: 'pl-3' },
        { text: 'Cupom', sortable: false, value: 'CUPOM', class: 'pl-3' },
        { text: 'Quantidade', sortable: false, align: 'right', value: 'VALUE', class: 'pa-0' },
        { text: '', value: 'GASOLINA', width: '0', sortable: false, class: 'pl2 pr-2' }
      ],
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailWidth: 150,
        maxFilesize: 0.5,
        headers: { 'My-Awesome-Header': 'header value' },
        dictDefaultMessage: 'Solte aqui os arquivos',
        previewTemplate: `
          <span tabindex="0" class="v-chip v-chip--removable theme--light teal white--text">
            <span class="v-chip__content">
              <div class="v-avatar" style="height: 48px; width: 48px;"><i aria-hidden="true" class="v-icon material-icons theme--light">check_circle</i></div>
              <div class="dz-filename"><span data-dz-name></span></div>
              <div class="v-chip__close dz-remove" data-dz-remove>
                <i aria-hidden="true" class="v-icon material-icons theme--light">cancel</i>
              </div>
            </span>
          </span>`,
        duplicateCheck: true
      }
    }
  },
  mounted () {
    if (this.consolidacao.vouchers && this.consolidacao.vouchers.length) {
      this.report = Array.from(this.consolidacao.vouchers)
    }
    this.pegarAutomacao()
  },
  computed: {
    status () {
      let concluidos = 0
      let pendentes = 0
      if (this.timeline) {
        this.timeline.forEach(function (element) {
          concluidos += (element.consolidada ? 1 : 0)
          pendentes += (element.pendente ? 1 : 0)
        })
      }
      return {
        concluidos: concluidos,
        pendentes: pendentes
      }
    },
    totalConsolidacao () {
      return 100
    },
    timeline () {
      if (!this.report) return null
      let timelineTemp = Array.from(this.report)
      this.files.forEach(file => {
        for (let key in file) {
          let cardItem = file[key]
          if (cardItem.codigo_cupom !== null && cardItem.codigo_cupom !== undefined) {
            timelineTemp.forEach(timelineItem => {
              if (timelineItem.numero.toUpperCase() === cardItem.codigo_cupom.toUpperCase()) {
                if (!timelineItem.consolidada) {
                  timelineItem.pendente = true
                }
                timelineItem.apetrus = false
                timelineItem.item = cardItem.item
                timelineItem.motorista = cardItem.motorista
              }
            })
            // if (!find) {
            //   timelineTemp.push(cardItem)
            // }
          }
        }
      })
      return timelineTemp
    }
  },
  methods: {
    updateElement: function (item) {
      Object.assign(this.report[item.index], item.element)
    },
    fileadded: function (file) {
      return false
    },
    comment () {
      this.input = null
    },
    handleDragover (e) {
      e.stopPropagation()
      e.preventDefault()
      e.dataTransfer.dropEffect = 'copy'
    },
    loadWorksheet (workbook) {
      // definir o worksheet
      const worksheet = workbook.worksheets[0]
      const headerPosition = this.automacao.linha_cabecalho || 1
      const headerRow = worksheet.getRow(headerPosition)
      if (!headerRow.hasValues) { return false }
      var col = this.automacao.nota_field
      if (col) {
        try {
          headerRow.eachCell((cel, i) => {
            if (cel.value === this.automacao.nota_field) {
              // retorna o valor correto via exceção
              throw i
            }
          })
        } catch (e) {
          // definindo a coluna via try-catch
          col = e
        }
      }
      if (!col) { return false }

      var docFile = []
      try {
        worksheet.eachRow((row, i) => {
          if (i <= headerPosition) {
            return
          }
          if (!row.hasValues || !row.getCell(col).value) {
            throw i
          }
          docFile.push({
            codigo_cupom: (row.getCell(col).value + '').trim()
          })
        })
      } catch (e) {
        console.log('resultado', e)
      }
      this.files.push(docFile)
    },
    handleDrop (f) {
      const workbook = new ExcelJS.Workbook()
      var extension = f.name.split('.')[1]
      if (extension === 'xlsx') {
        f.arrayBuffer().then(async (excelData) => {
          await workbook.xlsx.load(excelData)
          this.loadWorksheet(workbook)
        })
      } else if (extension === 'csv') {
        f.stream().then(async (excelData) => {
          await workbook.csv.read(excelData)
          this.loadWorksheet(workbook)
        })
      }
    },
    pegarAutomacao () {
      this.$store.dispatch('carregarAutomacao', true).then(json => {
        this.automacao = json
      })
    }
  }
}
</script>

<style>
  .excel-consolidar .vue-dropzone {
    padding: 0
  }

  .excel-consolidar .vue-dropzone .dz-message {
    margin-top: 15px;
    margin-bottom: 10px
  }

  .vue-dropzone {
    border: 0px solid #e5e5e5;
  }

  .no-overflow .v-table__overflow {
    overflow: hidden;
  }

  .dz-filename {
    white-space: nowrap;
    width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
